/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { FunctionComponent, useCallback } from "react";
import { Button } from "@itwin/itwinui-react";

export interface PaginationButtonProps {
  label: string;
  active?: boolean;
  value: number;
  disabled?: boolean;
  onClick?: (value: number) => void;
}

export const PaginationButton: FunctionComponent<PaginationButtonProps> = ({ label, active, value, disabled, onClick: callback }) => {

  const onClick = useCallback(() => {
    if (callback) {
      callback(value);
    }
  }, [callback, value]);

  return <Button styleType={active ? "high-visibility" : "borderless"} onClick={onClick} disabled={disabled}>{label}</Button>;
};

